import React, { useRef } from "react"
import { duration, gsap, useGSAP } from "@/utils/gsap"
import styled from "styled-components"
import { BREAKPOINTS } from "@/styles/themeSettings"
import { getCssSizeValue } from "@/utils/utils"

const SingleActionButtonWrapper = styled.div`
	width: 100%;
	aspect-ratio: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	border: 1px solid ${({ theme }) => theme.colors.richBlack};
	transition: background-color 0.3s ease-in-out;
	background-color: transparent;
	cursor: pointer;

	&:first-child {
		margin-bottom: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			margin-bottom: ${getCssSizeValue(16, BREAKPOINTS.DESKTOP)};
		}
	}

	&:last-child {
		border: 1px solid ${({ theme }) => theme.colors.richBlack};
		margin-top: -1px;
	}

	&.active {
		transition: background-color 0.3s ease-in-out;
		background-color: ${({ theme }) => theme.colors.periwinkle};
	}

	svg {
		transform: scale(0.75);
	}
`

const SingleActionButton = ({ children, className, onClick }) => {
	const ButtonRef = useRef()
	const { contextSafe } = useGSAP({ scope: ButtonRef })
	const animateCrushOnClick = contextSafe(() => {
		const tl = gsap.timeline()
		const dur = duration / 3
		tl.to(ButtonRef.current, {
			scale: 0.95,
			duration: dur,
			ease: "sine.out",
		}).to(ButtonRef.current, {
			scale: 1,
			duration: dur,
			ease: "sine.in",
		})
	})
	return (
		<SingleActionButtonWrapper
			className={className}
			ref={ButtonRef}
			onClick={() => {
				onClick()
				animateCrushOnClick()
			}}
		>
			{children}
		</SingleActionButtonWrapper>
	)
}

export default SingleActionButton
